var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-20 flex justify-center items-center bg-no-repeat bg-cover bg-bottom",style:({
    backgroundImage: `url(${_vm.image})`,
  })},[_c('ContainerView',{},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }